import type { FunctionComponent } from 'react';
import { Card } from '@george-labs.com/design-system';

import { LANGUAGE_KEYS_MODE_URL_PARAM } from '@luna/i18n';
import { getFeatureConfig } from '@luna/feature-config';

import { DevToolsCard } from '../DevToolsCard';
import { UrlParamToggle } from './UrlParamToggle';
import { RgbModeToggle } from './RgbModeToggle';
import { CustomEnvironmentInput } from './CustomEnvironmentInput';
import { EnvironmentSwitchButtonGroup } from './EnvironmentSwitchButtonGroup';
import styles from './EnvironmentCard.module.scss';
import { LanguageSwitch } from '../language-switch/LanguageSwitch';
import { DarkModeToggle } from './DarkModeToggle';
import { SimulateTemporaryMessageToggle } from './SimulateTemporaryMessageToggle';
import { LayoutSwitch } from '../app-switch/AppSwitch';

export const EnvironmentCard: FunctionComponent = () => {
    const { showLanguageSwitch, showSimulateTempMessage, showRgbMode, availableEnvironments } =
        getFeatureConfig((config) => config.devTools) || {};

    return (
        <Card nested={false} className={`my-0 rounded-0 ${styles.card}`}>
            <DevToolsCard title="Mode toggles">
                <UrlParamToggle
                    paramName={LANGUAGE_KEYS_MODE_URL_PARAM}
                    label="Language keys mode"
                />
                {showSimulateTempMessage && <SimulateTemporaryMessageToggle />}
                {showRgbMode && <RgbModeToggle />}
                <DarkModeToggle />
            </DevToolsCard>
            <LayoutSwitch />
            {showLanguageSwitch && <LanguageSwitch />}
            {availableEnvironments && (
                <DevToolsCard title="Environment switch">
                    <EnvironmentSwitchButtonGroup />
                    <CustomEnvironmentInput />
                </DevToolsCard>
            )}
        </Card>
    );
};
